import React, { useCallback, useMemo } from "react";
import * as Scrivito from "scrivito";
import cx from "classnames";

import { Select } from "./Select/Select";
import { useTranslate } from "hooks";
import { resultsNumberOptions } from "variables";

type ItemsPerPageOption = {
  label: string;
  value: number;
};

type ItemsPerPageSelectProps = {
  itemsPerPage: number;
  onChange: (itemsPerPage: number) => void;
  className?: string;
};

export const ItemsPerPageSelect = Scrivito.connect(
  ({ itemsPerPage, onChange, className }: ItemsPerPageSelectProps) => {
    const translate = useTranslate();

    const handleSelectChange = useCallback(
      (selectedOption: ItemsPerPageOption | null) => {
        if (!selectedOption) {
          return;
        }

        onChange(Number(selectedOption.value));
      },
      [onChange],
    );

    const selectedOption = useMemo<ItemsPerPageOption | undefined>(
      () =>
        resultsNumberOptions.find((option) => option.value === itemsPerPage),
      [itemsPerPage],
    );

    const currentPageObjClass = useMemo(
      () => Scrivito.currentPage()?.objClass(),
      [],
    );

    const labelText =
      currentPageObjClass === "ProjectList"
        ? translate("PROJECTS_PER_PAGE")
        : translate("ITEMS_PER_PAGE");

    return (
      <div
        className={cx(
          "d-flex font-md align-items-center gap-1 text-gray-700",
          className,
        )}
      >
        <div>{labelText}</div>
        <Select
          options={resultsNumberOptions}
          onChange={handleSelectChange}
          value={selectedOption}
          name="itemsPerPage"
          className="font-md"
        />
      </div>
    );
  },
);
